import React from 'react'

import { copyToClipboard } from "../utils/copyToClipboard"
import { creativeTypeOpsMap, typesMap } from '../utils/constants';


const CreativeNameDisplay = ({ preview }) => {
    if (!preview?.name) return null;

    const creativeType = creativeTypeOpsMap.get(preview.creative_type);
    const subType = typesMap.get(preview.sub_type);

    return (
        <div className="flex flex-col flex-wrap m-2 p-2 gap-2 bg-slate-50 rounded shadow-md">
            <h4>Type : {creativeType}</h4>
            <h4>Sub Type : {subType}</h4>
            <div className="flex gap-4 items-center">
                <h4 className="break-all">Name: {preview.name}</h4>
                <sl-icon
                    library="lucide"
                    name="copy"
                    slot="prefix"
                    data-toggle="tooltip"
                    title="Copy creative name"
                    className="cursor-pointer m-1 p-1 bg-slate-200 hover:text-cyan-500 rounded-md flex-shrink-0"
                    onClick={() => copyToClipboard(preview.name)}
                />
            </div>
        </div>
    );
}

export default CreativeNameDisplay;
